<template>
  <div class="google-pay-method">
    <div class="method" :class="{ noClick: loadingShow }" @click="handleGooglePay" v-if="price">
      <div class="methods">
        <div class="method-img">
          <img v-if="env.isAppIOS" src="@/assets/packageAssets/common/apple_pay.png" alt="" />
          <img v-else src="@/assets/packageAssets/common/google.png" alt="" />
        </div>
        <div class="line"></div>
        <div class="method-name">
          <span v-if="env.isAppIOS">Apple Pay</span>
          <span v-else>Google Pay</span>
          <div class="rate">
            <!-- prettier-ignore -->
            <div class="pay-price">
              <i>{{ currency }}</i><span>{{ price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loadingShow: {},
    price: {},
    currency: {}
  },
  data() {
    return {
      flag: false
    }
  },
  methods: {
    handleGooglePay() {
      // 与vava的不同
      this.$emit('handleAppleAndGooglePay')
    }
  }
}
</script>

<style lang="less" scoped>
.google-pay-method {
  .method {
    width: 100%;
  }
  .methods {
    display: flex;
    align-items: center;
    width: 100%;
    height: 56px;
    padding: 0 16px 0 8px;
    margin-bottom: 20px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;

    .method-img {
      display: flex;
      justify-content: center;
      > img {
        height: 32px;
        object-fit: contain;
      }
    }
    .line {
      height: 20px;
      margin: 0 5px;
      border-right: 1px solid #d8d8d8;
    }
    .method-name {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      line-height: 17px;
      font-family: Outfit-Bold;
      font-weight: 500;
      font-size: 14px;
      color: #222222;

      .rate {
        display: flex;
        align-items: center;
        .pay-price {
          position: relative;
          padding: 3px 10px;
          line-height: 22px;
          border-radius: 6px;
          background: #f9f4ed;
          color: #ffd786;
          font-family: Outfit-Bold;
          display: flex;
          align-items: center;
          > i,
          > span {
            color: #ff7f2d;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Outfit-Bold;
            font-style: normal;
            font-weight: 500;
          }
          > i {
            color: #ff7f2d;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Outfit-Bold;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
          }
          > span {
            font-size: 14px;
            margin-left: 2px;
          }
        }
        .pay-loading {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .actTextColor {
          opacity: 0.1;
        }
      }
    }
  }
  .noClick {
    pointer-events: none;
  }
}
</style>
